import { PdSubmitDialog } from "./pd-submit-dialog/PdSubmitDialog.js";
//#region src/pd-submit-dialog/pd-submit-dialog.ts
var tag = "pd-submit-dialog";
if (!customElements.get(tag)) customElements.define(tag, PdSubmitDialog);
//#endregion
export { PdSubmitDialog };
